import type { RendererProps } from "../core/element-registry"
import { useRenderContext } from "../core/render-context"
import { ElementRenderer } from "./element-renderer"

export function FormRenderer({ element }: RendererProps) {
  const { dispatchEvent } = useRenderContext()

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const formData = new FormData(e.currentTarget)
    const data: Record<string, string> = {}
    formData.forEach((value, key) => {
      data[key] = String(value)
    })
    dispatchEvent(element.id, "submit", { data })
  }

  return (
    <form
      onSubmit={handleSubmit}
      className={element.className}
      data-testid={`form-${element.id}`}
    >
      {element.children?.map((child) => (
        <ElementRenderer key={child.id} element={child} />
      ))}
    </form>
  )
}
